"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// import { getInvoiceCode } from '@hudled/end2end';
var material_1 = require("@mui/material");
var SimpleNoWrap_1 = __importDefault(require("atomicComponents/atoms/Text/SimpleNoWrap"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var Source = function (_a) {
    var item = _a.item;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ component: SimpleNoWrap_1.default, sx: { svg: { color: 'riverstone' } } }, { children: [(item === null || item === void 0 ? void 0 : item.isManual) && 'Manual input', item === null || item === void 0 ? void 0 : item.sourceInvNumber, (item === null || item === void 0 ? void 0 : item.sourceInvoiceId) && (item === null || item === void 0 ? void 0 : item.rechVendorId) === 'Xero' && ((0, jsx_runtime_1.jsx)(IconButtons_1.DownloadInvoiceButton, { mt: -0.5, url: "https://in.xero.com/".concat(item === null || item === void 0 ? void 0 : item.sourceInvoiceId) }))] })));
};
exports.default = Source;
